import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { TierBadge } from "@/components/TierBadge";
import { api } from "@/lib/api";

export const CustomerPicker = ({ value, onPick, testId = "basket-customer" }) => {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  useEffect(() => {
    if (q.trim().length < 2) return setRes([]);
    const t = setTimeout(() => api.get("/customers", { params: { search: q } }).then((r) => setRes(r.data.items.slice(0, 8))).catch(() => setRes([])), 300);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
      <Input data-testid={`${testId}-search`} className="pl-9" placeholder={value?.name || "Cerca cliente per nome o carta"} value={q} onChange={(e) => setQ(e.target.value)} />
      {res.length > 0 && (
        <div className="absolute z-30 mt-1 w-full overflow-hidden rounded-lg border border-slate-200 bg-white shadow-lg" data-testid={`${testId}-results`}>
          {res.map((c) => (
            <button key={c.id} data-testid={`${testId}-option-${c.id}`} onClick={() => { onPick(c); setQ(""); setRes([]); }}
              className="flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-slate-50">
              <span><span className="font-medium text-slate-800">{c.name}</span><span className="ml-2 text-xs text-slate-400">{c.card || c.email}</span></span>
              <TierBadge tier={c.tier} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
